(function(){
  var root=document.querySelector('.lc');if(!root)return;
  var fmt=function(c){return (c/100).toFixed(2).replace('.00','').replace('.',',')+' zł'};

  /* licznik do północy (czas warszawski) */
  var cds=root.querySelectorAll('[data-cd]');
  function tick(){
    var now=new Date();
    var pl=new Date(now.toLocaleString('en-US',{timeZone:'Europe/Warsaw'}));
    var end=new Date(pl);end.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((end-pl)/1000));
    var t=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(function(x){return x<10?'0'+x:x}).join(':');
    for(var i=0;i<cds.length;i++)cds[i].textContent=t;
  }
  tick();setInterval(tick,1000);

  /* data dostawy */
  var eta=root.querySelector('[data-eta]');
  if(eta){
    var mn=+root.dataset.emin||3,mx=+root.dataset.emax||6;
    var d=['niedz.','pon.','wt.','śr.','czw.','pt.','sob.'];
    var add=function(n){var x=new Date();x.setDate(x.getDate()+n);return d[x.getDay()]+' '+('0'+x.getDate()).slice(-2)+'.'+('0'+(x.getMonth()+1)).slice(-2)};
    eta.textContent='między '+add(mn)+' a '+add(mx);
  }

  /* zestawy */
  var packs=root.querySelectorAll('.lc-pack'),cur=root.querySelector('.lc-pack.is-on')||packs[0];
  var btnp=root.querySelector('[data-btnp]'),stl=root.querySelector('[data-stl]');
  function pick(el){
    for(var i=0;i<packs.length;i++){packs[i].classList.remove('is-on');packs[i].setAttribute('aria-checked','false')}
    el.classList.add('is-on');el.setAttribute('aria-checked','true');cur=el;
    if(btnp)btnp.textContent=fmt(+el.dataset.price);
    if(stl)stl.textContent=el.dataset.label+' · '+fmt(+el.dataset.price);
  }
  for(var i=0;i<packs.length;i++){(function(el){
    el.addEventListener('click',function(){pick(el)});
    el.addEventListener('keydown',function(e){if(e.key==' '||e.key=='Enter'){e.preventDefault();pick(el)}});
  })(packs[i])}
  /* ?variant= ze strony głównej zaznacza zestaw */
  var qv=new URLSearchParams(location.search).get('variant');
  if(qv)for(var j=0;j<packs.length;j++){if(packs[j].dataset.variant==qv){pick(packs[j]);break}}

  /* kupno: dodaj do koszyka i od razu do kasy */
  var msg=root.querySelector('[data-msg]');
  root.querySelectorAll('[data-buy]').forEach(function(b){
    b.addEventListener('click',function(){
      if(!cur)return;b.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+cur.dataset.variant,quantity:1}]})})
        .then(function(r){if(!r.ok)throw 0;location.href='/checkout'})
        .catch(function(){b.disabled=false;if(msg)msg.hidden=false});
    });
  });

  /* galeria: kropki */
  var gal=root.querySelector('[data-gal]'),dots=root.querySelectorAll('[data-dots] button');
  if(gal&&dots.length){
    gal.addEventListener('scroll',function(){var k=Math.round(gal.scrollLeft/gal.clientWidth);dots.forEach(function(x,j){x.classList.toggle('on',j==k)})},{passive:true});
    dots.forEach(function(x,j){x.addEventListener('click',function(){gal.scrollTo({left:j*gal.clientWidth,behavior:'smooth'})})});
  }

  /* przewijanie do zakupu */
  root.querySelectorAll('[data-scroll]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var t=document.getElementById('top-buy');if(t)t.scrollIntoView({behavior:'smooth',block:'start'})})});

  /* kalkulator godzin */
  var rg=root.querySelector('[data-range]');
  if(rg){var h=root.querySelector('[data-h]'),yh=root.querySelector('[data-yh]'),yd=root.querySelector('[data-yd]');
    var up=function(){var v=+rg.value;h.textContent=v+' h';yh.textContent=(v*365).toLocaleString('pl-PL');yd.textContent=Math.round(v*365/24)};rg.addEventListener('input',up);up();}

  /* sticky przycisk */
  var st=root.querySelector('[data-sticky]'),main=root.querySelector('.lc-buy .lc-btn');
  if(st&&main&&'IntersectionObserver' in window){
    var seen=false;
    new IntersectionObserver(function(en){var vis=en[0].isIntersecting;var past=en[0].boundingClientRect.top<0;st.classList.toggle('is-on',!vis&&past);st.setAttribute('aria-hidden',vis||!past?'true':'false');st.querySelector('button').tabIndex=(!vis&&past)?0:-1}).observe(main);
  }
})();
